module.exports = __webpack_public_path__ + "static/media/hope_you_join.2a4c2d2e.png";